import { useEffect, useState } from "react";
import { Card, CardBody, CardHeader } from "../../../../components/card/card";
import { atmpTrainingSummary } from "../../../../config/apiSPA";
import SpinnerSection from "../../../../components/spinner/spinnerSecion";

function AtmpResume({ year = "" }) {
  const [summaryState, setSummaryState] = useState();
  const [loadingData, setLoadingData] = useState(true);
  const loadData = async (y) => {
    setLoadingData(true);
    try {
      const res = await atmpTrainingSummary(y);
      setSummaryState(res);
    } catch (error) {
    } finally {
      setLoadingData(false);
    }
  };
  useEffect(() => {
    loadData(year);
  }, [year]);

  return loadingData ? (
    <SpinnerSection title="Loading" />
  ) : (
    <>
      <Card>
        <CardBody>
          <div className="row">
            <div className="col-lg-6">
              <div className="d-flex text-theme fw-400">Resume</div>
              <table className="table table-borderless table-sm m-0">
                <tbody>
                  <tr>
                    <td className="w-150px">Total</td>
                    <td className="text-end">{summaryState.total_event} Event</td>
                  </tr>
                  <tr>
                    <td>Training Internal</td>
                    <td className="text-end">{summaryState.total_internal} Event</td>
                  </tr>
                  <tr>
                    <td>Training External</td>
                    <td className="text-end">{summaryState.total_external} Event</td>
                  </tr>
                  <tr>
                    <td>Tentative</td>
                    <td className="text-end">{summaryState.total_tentative} Event</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </CardBody>
      </Card>
    </>
  );
}

export default AtmpResume;
